<ng-container *ngIf="isPublicRoute(); else adminShell">
  <router-outlet></router-outlet>
</ng-container>
<ng-template #adminShell>
  <app-shell class="shell">
    <router-outlet></router-outlet>
  </app-shell>
</ng-template>